import { ErrorMessage, Field } from "formik";
import React from "react";
import InfoTooltip from "./InfoTooltip";
import { cn } from "../lib/utils";

const FormField = ({
  name,
  label,
  icon,
  type = "text",
  as,
  rows,
  hasInfo = false,
  infoTitle = "",
  info = "",
  children,
  required = false,
}) => {
  return (
    <div className="flex flex-col gap-1">
      {/* Label */}
      <div className="flex items-center justify-between">
        <label
          htmlFor={name}
          className="flex items-center gap-1.5 text-xs font-semibold text-foreground/75 cursor-pointer select-none uppercase tracking-wide"
        >
          {icon &&
            React.createElement(icon, {
              className: "h-3 w-3 text-primary shrink-0",
            })}
          {label}
          {required && (
            <span className="text-secondary font-bold normal-case tracking-normal">*</span>
          )}
        </label>
        {hasInfo && <InfoTooltip title={infoTitle} text={info} />}
      </div>

      {/* Input / Textarea */}
      <Field name={name}>
        {({ field, meta }) => {
          const hasError = meta.touched && meta.error;
          const base = cn(
            "w-full rounded-lg border bg-background/50 text-foreground text-sm transition-all duration-150",
            "placeholder:text-muted-foreground/40",
            "focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary",
            "disabled:cursor-not-allowed disabled:opacity-50",
            hasError
              ? "border-destructive/70 focus:ring-destructive/20 focus:border-destructive"
              : "border-border/60 hover:border-border"
          );

          if (as === "textarea") {
            return (
              <textarea
                id={name}
                rows={rows || 2}
                className={cn(base, "px-3 py-2 resize-none")}
                {...field}
              />
            );
          }

          return (
            <input
              id={name}
              type={type}
              className={cn(base, "h-9 px-3")}
              {...field}
            >
              {children}
            </input>
          );
        }}
      </Field>

      <ErrorMessage
        name={name}
        component="p"
        className="text-[10px] text-destructive leading-none mt-0.5"
      />
    </div>
  );
};

export default FormField;
